import { type MaybeRefOrGetter, toValue } from 'vue'
import { z } from 'zod'
import {
  updateInvoiceSchema,
  type updateInvoiceCategoriesSchema,
  updateInvoiceChargesSchema
} from '@/features/invoices/schemas'
import { updateInvoiceTemplateCategories } from '@/features/invoices/api/updateInvoiceTemplateCategories'
import { fetchInvoiceQueryOptions, fetchInvoiceTemplateQueryOptions } from '@/features/invoices/queries'
import { useMutationWithInvalidation } from '@/shared/composables/useMutationWithInvalidation'
import { updateInvoice } from '@/features/invoices/api/updateInvoice'
import { updateInvoiceCategories } from '@/features/invoices/api/updateInvoiceCategories'
import { updateInvoiceCharges } from '@/features/invoices/api/updateInvoiceCharges'

export const useUpdateInvoiceTemplateCategories = (assetCode: MaybeRefOrGetter<string>) => useMutationWithInvalidation(
  (categories: z.infer<typeof updateInvoiceCategoriesSchema>) => updateInvoiceTemplateCategories(
    toValue(assetCode),
    categories
  ),
  [
    fetchInvoiceTemplateQueryOptions(assetCode).queryKey
  ]
)

export const useUpdateInvoice = (invoiceId: MaybeRefOrGetter<number>) => useMutationWithInvalidation(
  (input: z.infer<typeof updateInvoiceSchema>) => updateInvoice(toValue(invoiceId), input),
  [fetchInvoiceQueryOptions(invoiceId).queryKey]
)

export const useUpdateInvoiceCategories = (invoiceId: MaybeRefOrGetter<number>) => useMutationWithInvalidation(
  (input: z.infer<typeof updateInvoiceCategoriesSchema>) => updateInvoiceCategories(toValue(invoiceId), input),
  [fetchInvoiceQueryOptions(invoiceId).queryKey]
)

export const useUpdateInvoiceCharges = (invoiceId: MaybeRefOrGetter<number>) => useMutationWithInvalidation(
  (input: z.infer<typeof updateInvoiceChargesSchema>) => updateInvoiceCharges(toValue(invoiceId), input),
  [fetchInvoiceQueryOptions(invoiceId).queryKey]
)
